module.exports = __webpack_public_path__ + "img/chilim-coal.d6aad97e.png";